import { Application } from '@feathersjs/feathers'
import { SubmissionPayload } from '../components/ApplicationProgress/types'
import { User } from '../domain/user'
import { buildBaseUrl } from './app.config'
import { timeZoneOffsetHeader } from './user.session.service'

export const patchUser =
  (app: Application) =>
  (data: Partial<User>): Promise<User> => {
    return app.service('user').patch(null, data)
  }

export const addDataSource = (application: Application) => (): Promise<void> =>
  application.service('/user/dataSources/').update('creditCard', {})

export const mapUserPatchFields = (data: SubmissionPayload): Partial<User> => {
  const accessCode = localStorage.getItem('referral_code') || undefined

  return {
    givenName: data.name.first,
    familyName: data.name.last,
    middleName: data.name.middle,
    isOnboardingComplete: true,
    postalCode: data.address.postal,
    ...(accessCode && { accessCode })
  }
}

export const validateAccessCode = (code: string): Promise<boolean> => {
  return fetch(`https://${buildBaseUrl()}/accessCodes/${code}`, {
    headers: timeZoneOffsetHeader()
  })
    .then((response) => response.json())
    .then((data: AccessCodeData) => data.status === 'valid')
    .catch(() => false)
}

type AccessCodeData = {
  accessCode: string
  status: 'valid' | 'expired' | 'claimed'
  promotionCode: string // not "the code"!
}
